<template>
  <div>
    <div class="container">
    <h1>Angebote Freigeben</h1>
    </div>
    <div class="list">
        <div class="container">
          <div class="row">
            <div class="col-12">
            <Angebot :Angebote="Angebote" :user="User"/>
            </div>
          </div>
<!--          <Modal ref="modal"/>-->
        </div>
    </div>
  </div>
</template>

<script>
import Angebot from "@/components/angebot/admin/Angebot";

import AngebotService from "../../services/AngebotService";
//import Modal from "./Show";
import NProgress from "nprogress";
export default {
  name: "ListeFreigabe",
  components: {
    Angebot,
    //Modal
  },
  data(){
      return{
        Angebote: [],
        User: Object,
        Texte: ""
      }
  },
  methods: {
    showModal(id){
        this.$refs.modal.showIt(id)
      },
    refreshAngebote(){
      AngebotService.getAngeboteFreigegeben()
              .then(response => {
                let angebotData = response.data;
                this.Angebote = angebotData;

              })
              .catch(error => {
                console.log("There was an error:", error.response);
              });
    },
  },
  created() {
    let user = this.$store.getters.userObject;
    this.User = user;
    this.Texte = this.$locales.Texte.freigegeben;
    AngebotService.getAngeboteFreigegeben()
            .then(response => {
              let angebotData = response.data;
              this.Angebote = angebotData; // <--- set the events when returned
              
            })
            .catch(error => {
              console.log("There was an error:", error.response);
            });
  },
  
};
</script>
